import React, { useState } from "react";
import { Logo, Ornament } from "@/components/Logo";
import { FOOTER } from "@/constants/testIds";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await api.post("/email-signups", { email, source: "footer" });
      toast.success("You’re on the list.");
      setEmail("");
    } catch (err) {
      toast.error(
        formatApiError(err.response?.data?.detail) || "Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer
      data-testid={FOOTER.root}
      className="jewel-bg text-ivory pt-20 pb-10 relative overflow-hidden grain-overlay"
      style={{ color: "var(--ivory)" }}
    >
      <div className="relative max-w-[1400px] mx-auto px-6 sm:px-10 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <Logo size={96} />
          </div>
          <p className="mt-6 max-w-md text-sm text-ivory/70 leading-relaxed">
            A curated house presenting the original works of Tom Pergola. All
            transactions escrowed via Escrow.com. brushmaster.art
          </p>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37]">
            Stay in the studio
          </div>
          <h3 className="font-serif text-2xl mt-3 tracking-tight">
            Advance notice of new originals.
          </h3>
          <form onSubmit={submit} className="mt-6 flex gap-3">
            <input
              type="email"
              required
              data-testid={FOOTER.newsletterEmail}
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-transparent border-0 border-b border-[#D4AF37]/60 h-11 text-ivory placeholder:text-ivory/40 focus:outline-none focus:border-b-2 px-1"
              style={{ color: "var(--ivory)" }}
            />
            <button
              type="submit"
              data-testid={FOOTER.newsletterSubmit}
              disabled={submitting}
              className="btn-outline-gold rounded-none px-5 h-11 tracking-[0.25em] text-[10px] uppercase font-medium"
            >
              {submitting ? "…" : "Subscribe"}
            </button>
          </form>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37]">
            Contact
          </div>
          <div className="mt-4 text-sm text-ivory/80 space-y-2">
            <div>Edgar Hicks · National Coordinator</div>
            <a
              href="mailto:edhix26@brushmaster.art"
              className="hover:text-[#D4AF37] transition-colors block"
            >
              edhix26@brushmaster.art
            </a>
            <div>brushmaster.art</div>
          </div>
        </div>
      </div>

      <div className="relative max-w-[1400px] mx-auto mt-16 px-6 sm:px-10 flex items-center gap-6">
        <div className="flex-1 h-px bg-[#D4AF37]/30" />
        <Ornament color="#D4AF37" />
        <div className="flex-1 h-px bg-[#D4AF37]/30" />
      </div>

      <div className="relative max-w-[1400px] mx-auto mt-8 px-6 sm:px-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-[10px] tracking-[0.3em] uppercase text-ivory/50">
        <div>© {new Date().getFullYear()} House of Master Brushes Fine Art</div>
        <div>Payments secured by Escrow.com</div>
      </div>
    </footer>
  );
}
